const CITABILITY_COPY: Record<string, string[]> = {
  "/": [
    "CosyLab 是香港專業的手工藝到校課程供應商，總部位於香港，服務範圍涵蓋全港各區的中小學、社區中心及企業客戶。我們提供一站式到校課程服務，主題包括蠟燭製作、植物護理等療癒手作體驗，導師攜帶全套材料及工具上門授課，學校及機構無需額外準備設備。課程適合小學至中學的課後興趣班、校本特別活動及長期駐校合作，亦可為成人團體安排工作坊。查詢及預約可透過 WhatsApp（+852 8437 8839）或電郵 cosylabhk@gmail.com 聯絡。",
    "CosyLab 已與超過 20 間香港學校及機構合作，涵蓋天主教南華中學、培英中學、慕光英文書院等。導師具備豐富教學經驗，課程可按學校主題、學生年齡及活動目的度身訂造，並提供免費諮詢及報價。無論是單次工作坊還是整學年興趣班，CosyLab 均負責課前準備、課中指導及課後清潔收拾，致力為香港學校及社區提供安全、省心、具療癒效果的手工藝體驗。",
  ],
  "/school-program": [
    "CosyLab 學校方案專為香港中小學而設，提供一站式到校手工藝工作坊及課後興趣班服務。導師會攜帶香薰大豆蠟燭、多肉植物、苔蘚球等課程所需的全部材料及工具到校服務，學校只需提供課室及基本桌椅。課程適合 6 至 18 歲學生，亦可為教職員安排成人工作坊。我們曾服務超過 20 間香港學校，包括培英中學、天主教南華中學、慕光英文書院等，並可按學校預算、人數及學期安排提供彈性報價。",
    "預訂 CosyLab 學校到校課程的流程簡單：透過 WhatsApp（+852 8437 8839）或網站聯絡表格說明活動日期及人數，我們會安排免費諮詢，了解學校需求後提供度身訂造方案。確認日期後，導師負責所有課前準備、課堂指導及課後清潔收拾，不增加教職員工作量。CosyLab 服務覆蓋香港全港各區，適合課後興趣班、學校開放日、生涯規劃活動及長期駐校合作。",
  ],
  "/community-program": [
    "CosyLab 為香港企業、社區中心及非牟利機構提供上門手工藝工作坊，適合 Team Building、員工身心健康日、公司週年慶、社區節日活動及私人派對。常見課程包括香薰大豆蠟燭製作、多肉植物及苔蘚球種植、手作香氛產品等，可承接 10 至 50 人以上的活動。導師攜帶全套材料到客戶指定的辦公室、社區中心或活動場地，參加者無需任何手作經驗，全程由導師帶領完成作品。",
    "企業及社區客戶可透過 WhatsApp（+852 8437 8839）查詢 CosyLab 工作坊方案。我們提供免費諮詢，按活動人數、主題及場地提供客製化報價，並可在包裝或成品上加入公司 Logo 及品牌元素，適合客戶送禮及員工紀念品。CosyLab 服務香港全港，曾與超過 20 間機構合作，致力以療癒手作體驗提升團隊凝聚力及社區參與感。",
  ],
  "/classes": [
    "CosyLab 課程列表展示香港手工藝到校課程及工作坊的主題選擇，涵蓋蠟燭製作與植物護理兩大系列。蠟燭製作課程教授香薰大豆蠟燭、個人化杯蠟等技巧；植物護理課程則包括多肉植物栽種、苔蘚球製作及室內植物照顧入門。每項課程均由 CosyLab 專業導師設計，適合零經驗學員，並可按中小學生、成人團體或企業活動調整難度與時長。",
    "瀏覽 CosyLab 課程列表後，可點擊各課程查看詳情、教學內容及作品示例。學校及機構如需預約到校授課，建議同時參考學校方案或企業及社區方案頁面。CosyLab 總部位於香港，提供全港上門服務，查詢請透過 WhatsApp（+852 8437 8839）或電郵 cosylabhk@gmail.com 聯絡，我們會按活動性質提供合適課程建議及報價。",
  ],
  "/about": [
    "CosyLab 是香港手工藝教育品牌，專注提供療癒感的手作體驗及到校課程服務。品牌理念是以創意手作連結人與人，讓學員在慢節奏的製作過程中放鬆身心、表達自我。CosyLab 主理蠟燭製作、植物護理及多元化 DIY 主題，服務對象包括學校學生、親子家庭、情侶朋友、企業團隊及社區團體，課程內容會按參加者年齡與興趣調整。",
    "CosyLab 堅持使用優質安全材料，並以耐心指導確保每位學員都能完成滿意作品。我們重視社群連結與教學品質，已與香港多間學校及機構建立長期合作。無論是個人興趣、親子活動、企業 Team Building 或中學生涯規劃體驗，CosyLab 均提供專業導師及完整課程方案。查詢請透過 WhatsApp（+852 8437 8839）或網站聯絡我們。",
  ],
  "/contact": [
   "建議提供活動日期、預計人數、地點（學校或機構名稱）及課程偏好（如蠟燭製作或植物護理），以便我們更快提供度身訂造方案及報價。",
  ],
  "/portfolio": [
    "CosyLab 工作坊目錄匯總香港到校手工藝課程的主題方向、教學特色及可選方案，方便學校及機構在策劃活動時快速了解 CosyLab 的服務範圍。目錄涵蓋蠟燭製作、植物護理等療癒手作主題，並說明各課程適合的年齡層、活動形式及到校安排方式。",
    "瀏覽 CosyLab 工作坊目錄頁面後，可下載最新 PDF 課程資料作內部規劃及報價參考。如需按學校主題、節日活動或企業品牌需求度身訂造內容，請透過 WhatsApp（+852 8437 8839）聯絡 CosyLab 安排免費諮詢。CosyLab 總部位於香港，提供全港上門工作坊服務，適合課後興趣班、校本活動及社區節日。",
  ],
  "/partners": [
    "CosyLab 合作機構頁面展示曾與我們合作的本港學校及機構，包括培英中學、天主教南華中學、慕光英文書院、寧波第二中學、曾璧山中學、救世軍卜維廉中學等。這些合作涵蓋香港到校手工藝工作坊、課後興趣班及校本特別活動，反映 CosyLab 在本地教育及社區領域的實際服務經驗。",
    "CosyLab 歡迎香港學校、社區中心及企業洽談合作。我們提供一站式到校課程，導師攜帶全套材料上門，並可按合作機構的需求度身訂造課程內容。如您的學校或機構希望加入 CosyLab 合作夥伴網絡，請透過 WhatsApp（+852 8437 8839）或網站聯絡表格查詢，我們會安排免費諮詢及提供方案報價。",
  ],
};

export function getCitabilityParagraphs(pathname: string): string[] {
  const normalized =
    !pathname || pathname === "/" ? "/" : pathname.replace(/\/+$/, "") || "/";
  return CITABILITY_COPY[normalized] || [];
}
